// src/components/Celebrations/CelebrationActivitiesTab.js

import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { fetchActivitiesThunk } from '../../redux/fetchProjectsThunk';
import { createEventRequestThunk } from '../../redux/createEventRequestThunk';
import { resetEventRequestStatus } from '../../redux/eventRequestSlice';
const CelebrationActivitiesTab = ({ item, category_id = 0 }) => {
  const dispatch = useDispatch();
  const [selectedActivities, setSelectedActivities] = useState({});

  const {
    activities: {
      list: allActivities = [],
      loading: activityLoading,
      error: activityError,
    } = {}
  } = useSelector((state) => state.projects.eventDetails.celebration || {});

  const { loading, success, error } = useSelector((state) => state.eventRequest);

  useEffect(() => {
    if (item?.celebration_id) {
      dispatch(fetchActivitiesThunk({ category_id, event_id: item.celebration_id }));
    }
  }, [dispatch, category_id, item?.celebration_id]);

  useEffect(() => {
    if (success || error) {
      const timer = setTimeout(() => {
        dispatch(resetEventRequestStatus());
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [success, error, dispatch]);

  const handleCheckboxChange = (activityId) => {
    setSelectedActivities((prev) => ({
      ...prev,
      [activityId]: !prev[activityId],
    }));
  };

  const handleSubmitActivities = () => {
    const selected = allActivities.filter((act) => selectedActivities[act.id]);

    if (selected.length === 0) {
      alert('Please select at least one activity.');
      return;
    }

    const formattedDate = moment(item.date, "DD-MM-YYYY").format("YYYY-MM-DD");

    const payload = {
      event_name: item.name || "Unnamed Celebration",
      event_date: formattedDate,
      activities: selected.map((act) => ({
        activity_name: act.activity || act.name || "",
        activity_desc: act.activity_desc || act.description || "",
      })),
    };

    dispatch(createEventRequestThunk(payload));
    setSelectedActivities({});
  };

  const hasSelectedActivities = Object.values(selectedActivities).some(Boolean);

  return (
    <div className="card card-body">
      <h3 className=' my-0 text-18'>Activities for {item.name || item.details}</h3>
      <p className='mb-3'>Select activities to add to this celebration's schedule.</p>

      {activityLoading ? (
        <p>Loading activities...</p>
      ) : activityError ? (
        <div className="alert alert-danger">Error loading activities: {activityError.message || activityError}</div>
      ) : allActivities.length > 0 ? (
        <>
          <div className="activities-list row">
            {allActivities.map((activity) => (
              <div className="form-check mb-2 col-md-4" key={activity.id}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`activity-${activity.id}`}
                  checked={!!selectedActivities[activity.id]}
                  onChange={() => handleCheckboxChange(activity.id)}
                />
                <label className="form-check-label" htmlFor={`activity-${activity.id}`}>
                  <strong>{activity.activity || activity.name}</strong>
                  <br />
                  <small className="text-muted">{activity.activity_desc || activity.description}</small>
                </label>
              </div>
            ))}
          </div>

          {hasSelectedActivities && (
            <div className="d-grid gap-2 mt-4">
              <button
                className="btn btn-success btn-lg"
                onClick={handleSubmitActivities}
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Submit Selected Activities'}
              </button>
            </div>
          )}

          {success && (
            <div className="alert alert-success mt-3">
              Celebration activities submitted successfully!
            </div>
          )}

          {error && (
            <div className="alert alert-danger mt-3">
              Error: {error}
            </div>
          )}
        </>
      ) : (
        <div className="alert alert-info mt-3">
          <h4 className="alert-heading">No activities found for "{item.name || item.details}"</h4>
          <p>This event does not have any activities loaded from the server yet.</p>
        </div>
      )}
    </div>
  );
};

export default CelebrationActivitiesTab;
